export const Logo = ({ className = "h-8", invert = true }) => (
  <img
    src="/assets/entrolabs-logo.png"
    alt="EntroLabs IT Solutions"
    className={`${className} ${invert ? "logo-invert" : ""} w-auto object-contain`}
    draggable={false}
  />
);

export default Logo;
